import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SelectorChip from 'components/DesignSystem/SelectorChip';
import range from 'helper/range';
import { DisplayMode, Gifs } from 'helper/products/synopticCharts';
import {
  selectGifIndex,
  selectGifs,
  selectGifsAreLoading,
  setDisplayMode,
  setGifIndex,
} from 'redux/reducers/synopticChartsReducer';

export default function PentadGifNav() {
  const dispatch = useDispatch();
  const gifs: Gifs | undefined = useSelector(selectGifs);
  const isLoading: boolean = useSelector(selectGifsAreLoading);
  const selectedIndex: number = useSelector(selectGifIndex);

  const available = !!gifs && gifs.length > 0;
  const disabled = isLoading || !available;

  const handleSelect = (index: number) => {
    dispatch(setGifIndex(index));
    dispatch(setDisplayMode(DisplayMode.Gif));
  };

  return (
    <div className="sc-mobile-pentad-gif-nav">
      {range(3).map((index) => {
        const active = available && selectedIndex === index;
        return (
          <SelectorChip
            key={`gif-pentad-${index}`}
            shape="cell"
            selected={active}
            disabled={disabled}
            className="sc-mobile-pentad-gif-option"
            onClick={() => handleSelect(index)}
          >
            {`Pêntada ${index + 1}`}
          </SelectorChip>
        );
      })}
    </div>
  );
}
